module.exports = __webpack_public_path__ + "img/39.60865500.jpg";